import Medium from './medium'
import Large from './large'
import Huge from './huge'


export default {
    Medium,
    Large,
    Huge,
}